// material-ui
import { PaletteMode } from '@mui/material';
import { createTheme } from '@mui/material/styles';

// assets
import theme1 from 'src/assets/scss/_theme1.module.scss';
import theme2 from 'src/assets/scss/_theme2.module.scss';
import theme3 from 'src/assets/scss/_theme3.module.scss';
import theme4 from 'src/assets/scss/_theme4.module.scss';
import theme5 from 'src/assets/scss/_theme5.module.scss';
import theme6 from 'src/assets/scss/_theme6.module.scss';
import defaultColor from 'src/assets/scss/_themes-vars.module.scss';
import { ColorProps } from 'src/types';
import { colorsForTesting, isTestingWithJest } from 'src/utils/test-utils';

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = (navType: PaletteMode, presetColor: string) => {
    let colors: ColorProps;
    switch (presetColor) {
        case 'theme1':
            colors = theme1;
            break;
        case 'theme2':
            colors = theme2;
            break;
        case 'theme3':
            colors = theme3;
            break;
        case 'theme4':
            colors = theme4;
            break;
        case 'theme5':
            colors = theme5;
            break;
        case 'theme6':
            colors = theme6;
            break;
        case 'default':
        default: {
            if (isTestingWithJest()) {
                colors = colorsForTesting();
            } else {
                colors = defaultColor;
            }
        }
    }

    const { palette } = createTheme();

    return createTheme({
        palette: {
            mode: navType,
            common: {
                black: colors.darkPaper,
                white: colors.paper,
                orange: colors.light3,
            },
            primary: {
                light: navType === 'dark' ? colors.darkPrimaryLight : colors.primaryLight,
                main: navType === 'dark' ? colors.darkPrimaryMain : colors.primaryMain,
                dark: navType === 'dark' ? colors.darkPrimaryDark : colors.primaryDark,
                200: navType === 'dark' ? colors.darkPrimary200 : colors.primary200,
                800: navType === 'dark' ? colors.darkPrimary800 : colors.primary800,
            },
            secondary: {
                light: navType === 'dark' ? colors.darkSecondaryLight : colors.secondaryLight,
                main: navType === 'dark' ? colors.darkSecondaryMain : colors.secondaryMain,
                dark: navType === 'dark' ? colors.darkSecondaryDark : colors.secondaryDark,
                200: navType === 'dark' ? colors.darkSecondary200 : colors.secondary200,
                800: navType === 'dark' ? colors.darkSecondary800 : colors.secondary800,
            },
            error: {
                light: colors.errorLight,
                main: colors.errorMain,
                dark: colors.errorDark,
            },
            orange: {
                light: colors.orangeLight,
                main: colors.orangeMain,
                dark: colors.orangeDark,
                main2: colors.main2,
                light2: colors.light2,
                light3: colors.light3,
            },
            warning: {
                light: colors.warningLight,
                main: colors.warningMain,
                dark: colors.warningDark,
                medium: '#C71515',
            },
            success: {
                light: colors.successLight,
                200: colors.success200,
                main: colors.successMain,
                dark: colors.successDark,
            },
            blue: {
                light: '#27AE96',
                dark: '#104CE5',
            },
            grey: {
                primary: colors.grey,
                100: colors.grey100,
                200: colors.grey200,
                300: colors.grey300,
                400: colors.grey400,
                500: colors.grey500,
                600: colors.grey600,
                700: colors.grey700,
                800: colors.grey800,
                900: colors.grey900,
            },
            dark: {
                light: colors.darkTextPrimary,
                main: colors.darkLevel1,
                dark: colors.darkLevel2,
                800: colors.darkBackground,
                900: colors.darkPaper,
            },
            text: {
                primary: colors.text500,
                secondary: colors.text100,
                dark: colors.text800,
                hint: colors.grey100,
                400: colors.text400,
                200: colors.text200,
                300: colors.text300,
                1000: colors.text1000,
                teal: '#27AE96',
            },
            divider: navType === 'dark' ? colors.darkTextPrimary : colors.grey200,
            background: {
                paper: colors.paper,
                default: colors.paper,
                info: '#FFD54F',
                error: '#E57373',
                warn: '#F0C2A5',
                lightOrange: '#FEF4D3',
            },
            border: {
                main: palette.primary.main,
                primary: '#FFEA99',
                light: '#F39E4E',
                white: '#fff',
                disabled: '#ccc',
                custom: '#FEE380 solid 1px',
                info: '1px solid #F0C32E',
                warn: '1px solid #F0C2A5',
                error: '1px solid #EF1D1D',
            },
            shadow: {
                primary: '0px 4px 20px 0px #2632381a',
            },
            action: {
                tableRowHover: '#fffbe9',
            },
        },
    });
};

export default Palette;
